var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgText11(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 50,
    viewBox: "0 0 46 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 3002"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 3074"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.9,
    d: "M25.0469 4.3125V28.7031H0.710938V4.3125H25.0469ZM8.47656 10.5469V22.5781H17.2812V10.5469H8.47656ZM39.375 0.320312V14.4844H45.8828V20.9375H39.375V36.8516H31.5V0.320312H39.375ZM41.0156 43.3594V49.6484H6.45312V33.1875H14.3281V43.3594H41.0156Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgText11);
export default __webpack_public_path__ + "static/media/text11.f5e9f9b7efb3d343a889e37369826fca.svg";
export { ForwardRef as ReactComponent };